"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    OverlayDrawerSurfaceClassNames: function() {
        return OverlayDrawerSurfaceClassNames;
    },
    useOverlayDrawerSurfaceStyles_unstable: function() {
        return useOverlayDrawerSurfaceStyles_unstable;
    }
});
const _react = require("@griffel/react");
const OverlayDrawerSurfaceClassNames = {
    root: 'fui-OverlayDrawerSurface',
    backdrop: 'fui-OverlayDrawerSurface__backdrop'
};
/**
 * Styles for the backdrop slot
 */ const useBackdropResetStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rmnljus", null, [
    ".rmnljus{inset:0px;position:fixed;background-color:rgba(0, 0, 0, 0.4);}"
]);
const useBackdropStyles = /*#__PURE__*/ (0, _react.__styles)({
    nested: {
        De3pzq: "f1c21dwh"
    }
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}"
    ]
});
const useOverlayDrawerSurfaceStyles_unstable = (state)=>{
    'use no memo';
    const backdropResetStyles = useBackdropResetStyles();
    const backdropStyles = useBackdropStyles();
    if (state.backdrop) {
        state.backdrop.className = (0, _react.mergeClasses)(backdropResetStyles, state.isNestedDialog && backdropStyles.nested, state.backdrop.className);
    }
    return state;
}; //# sourceMappingURL=useOverlayDrawerSurfaceStyles.styles.js.map
